import React from 'react';
import { DataTableActions } from 'src/components/DataTable';
import { useModal } from 'src/hooks';
import { isModalComplete } from 'src/components/ModalDialog';
import AlertViewModal from './AlertViewModal';
import { alertItem } from '../types';

type Props = {
  item?: alertItem;
};

function AlertListAction({ item }: Props) {
  const onClose = (event, reason) => isModalComplete(reason);

  const [ViewDialog, handleView] = useModal(AlertViewModal, {
    item,
    onClose,
  });

  return (
    <DataTableActions
      canView={true}
      onView={handleView}
      showView={true}
      showEdit={false}
      showDelete={false}
    >
      {ViewDialog}
    </DataTableActions>
  );
}

export default AlertListAction;
